import { inject, Pipe, PipeTransform } from '@angular/core';
import { TagStore } from '../stores/tag/tag.state';

export interface TagSummary {
  /** The first titles, comma separated. */
  shown: string;
  /** Number of further tags. */
  rest: number;
  /** All titles, e.g. for a tooltip. */
  all: string;
}

/**
 * Condenses tag ids to a short text for pick-list meta lines:
 * `{{ (indicator.tags | tagSummary).shown }}`.
 * Impure, because tags may be loaded after the first render.
 */
@Pipe({
  name: 'tagSummary',
  standalone: true,
  pure: false,
})
export class TagSummaryPipe implements PipeTransform {
  private readonly tagStore = inject(TagStore);

  transform(tagIds: string[] | undefined | null, max = 2): TagSummary {
    const items = this.tagStore.items();
    const titles = (tagIds || [])
      .map(id => items[id]?.title)
      .filter((title): title is string => !!title);
    return {
      shown: titles.slice(0, max).join(', '),
      rest: Math.max(0, titles.length - max),
      all: titles.join(', '),
    };
  }
}
